
import { useEffect } from 'react'
import { useAuthStore } from '@/stores'

const SESSION_DURATION = 24 * 60 * 60 * 1000 // 24 hours

export function SessionManager() {
    const { isAuthenticated, loginTimestamp, logout, fetchCurrentUser } = useAuthStore()

    useEffect(() => {
        if (!isAuthenticated) return

        const checkSession = async () => {
            const now = Date.now()

            // Check if session has exceeded duration
            if (loginTimestamp && (now - loginTimestamp > SESSION_DURATION)) {
                await logout()
                window.location.href = '/login'
                return
            }

            // Verify user existence and token validity
            // This handles the "recreated user" case where token is valid but user is gone (404)
            await fetchCurrentUser()
        }

        // Check immediately on mount
        checkSession()

        // Check periodically (every 5 minutes)
        const interval = setInterval(checkSession, 5 * 60 * 1000)

        return () => clearInterval(interval)
    }, [isAuthenticated, loginTimestamp, logout, fetchCurrentUser])

    return null
}
